document.addEventListener("DOMContentLoaded", function () {
  const targetDiv = document.querySelector(".aw-search-div");
  if (targetDiv) {
    targetDiv.childNodes[0].nodeValue = "Cerca Punto Vendita: ";
  }

  const inputElement = document.getElementById("pac-input");
  if (inputElement) {
    inputElement.placeholder = "Inserisci CAP o città";
  }

  const mapElement = document.getElementById("map");

  if (mapElement) {
    mapElement.addEventListener("click", function () {
      console.log("## Map element was clicked!");
    });

    // not working :(
    const linkElement = document.querySelector("a.aw-get-direction"); // Selects the link by class
    if (linkElement) {
      // Add 4px margin to the top
      linkElement.style.marginTop = "4px";

      // Change the inner text
      linkElement.innerText = "Apri in Google Maps"; // New inner text
    }
  }
});

// Function to check if the element is visible in the viewport
function isElementVisible(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Callback function when mutations are detected
function observeElement() {
  const targetElement = document.querySelector(".gm-style-iw"); // Target the element by class name

  if (targetElement && isElementVisible(targetElement)) {
    // console.log("Element appeared on the screen:", targetElement);

    // Change the inner text of "Get directions"
    const directionsLink = document.querySelector(".aw-get-direction"); // Target the element by class name

    if (directionsLink && directionsLink.innerText != "Apri in Google Maps") {
      directionsLink.innerText = "Apri in Google Maps"; // New inner text
    }

    observer.disconnect(); // Stop observing after detecting the element (optional)
  }
}

// Configure the MutationObserver
const observer = new MutationObserver(() => observeElement());

// Start observing the entire body for changes in child nodes and subtree
observer.observe(document.body, {
  childList: true, // Observe direct children changes
  subtree: true, // Observe all descendants
});

// Check if element already exists on page load
observeElement();
